// extracted by mini-css-extract-plugin
export default {"mobileInstallButton":"Y6Oq1","buttonInner":"J2EcW","appStoreBadge":"VctqK","hiddenBadge":"DwKjN"};